export default class Auth {
	constructor() {
		document.addEventListener( 'DOMContentLoaded', this.ready() );
	}

	ready () {

		if (window.location.pathname !== '/auth/authenticate/') {
			return;
		 }

		setTimeout(() => {
			console.log('redirect');
			window.location = '/';
		}, 25000 );

		// check window.location for hash token
		const searchParams = new URLSearchParams(window.location.hash);
		const params = [
			'#code',
			'id_token',
			// 'access_token',
			// 'token_type',
			// 'expires_in',
			'scope',
			'state',
			'session_state'
		];
		let data = [];

		// Display the keys
		for (const key of params) {
			if (!searchParams.has(key)) {
				return;
			}
		}


		this.proxyAuth( searchParams );

	}

	async postData ( url = "", data = {} ) {
		const response = await fetch( url, {
			method: "POST", // *GET, POST, PUT, DELETE, etc.
			mode: "cors", // no-cors, *cors, same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				"Content-Type": "application/json",
				// 'Content-Type': 'application/x-www-form-urlencoded',
			},
			redirect: "follow", // manual, *follow, error
			referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
			body: JSON.stringify(data), // body data type must match "Content-Type" header
		});

		// console.log(response);

		return response.json(); // parses JSON response into native JavaScript objects
	}

	proxyAuth ( searchParams ) {

		const url = '/wp-json/ncasi/v1/handle_authenticate';
		let data = {};

		for (const [key, value] of searchParams.entries()) {
			data[key] = value;
		}

		this.postData( url, data ).then( ( data ) => {

			if ( data.redirect ) {
				window.location = data.redirect;
			}


		});

	}
}
